import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const StoreAndUpdateSocialLinksThunk = createAsyncThunk(
	"SocialLinks/StoreAndUpdateSocialLinksThunk",
	async (arg, ThunkApi) => {
		const { rejectWithValue } = ThunkApi;

		try {
			const res = await axios.put(`api/social_links`, arg);

			return res.data;
		} catch (error) {
			return rejectWithValue(error.response.data?.data);
		}
	}
);
